// extracted by mini-css-extract-plugin
export default {"container":"AutoRenewal_container__n0ZJf","label":"AutoRenewal_label__7sS-n","description":"AutoRenewal_description__Fq0tt"};